/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Export_No_Event_Group_ErrorInputs */

const en_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No valid event group found for export`)
};

const fr_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe d'evenements valide trouve pour l'export`)
};

const de_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurde keine gültige Ereignisgruppe für den Export gefunden.`)
};

const it_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gruppo di eventi valido trovato per l'esportazione`)
};

const ru_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не найдена подходящая группа событий для экспорта.`)
};

const es_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró ningún grupo de eventos válido para la exportación`)
};

const zh_cn2_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到可导出的有效事件组`)
};

const ja_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートに有効なイベント グループが見つかりません`)
};

const hi_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात के लिए कोई वैध इवेंट समूह नहीं मिला`)
};

const pt_pt2_iframe_remote_export_no_event_group_error = /** @type {(inputs: Iframe_Remote_Export_No_Event_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum grupo de eventos válido encontrado para exportação.`)
};

/**
* | output |
* | --- |
* | "No valid event group found for export" |
*
* @param {Iframe_Remote_Export_No_Event_Group_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_export_no_event_group_error = /** @type {((inputs?: Iframe_Remote_Export_No_Event_Group_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Export_No_Event_Group_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "de") return de_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "it") return it_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "ru") return ru_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "es") return es_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "ja") return ja_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "hi") return hi_iframe_remote_export_no_event_group_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_export_no_event_group_error(inputs)
	return en_iframe_remote_export_no_event_group_error(inputs)
});